export default defineNuxtRouteMiddleware(async (to, from) => {
  const user = useUser()
  const { $newRelic, $faro } = useNuxtApp()

  await user.validate()
  console.log('$newRelic?.setUserId', user?.data?.email || null)
  $newRelic?.setUserId(user?.data?.email || null)
  $faro?.api?.setUser({ email: user?.data?.email || null })
})
